import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="mx-auto flex w-full max-w-screen-xl flex-col items-center px-4 py-24 text-center md:px-6">
      <span className="font-heading text-6xl font-bold text-primary-500 md:text-8xl">404</span>
      <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
        页面走丢了
      </h1>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
        你访问的页面不存在或已被移动。不妨回到首页，继续探索最新的电影资讯与精选片单。
      </p>
      <div className="mt-7 flex flex-wrap justify-center gap-3">
        <Link
          to="/"
          className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          回到首页
        </Link>
        <Link
          to="/category"
          className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:bg-background-100"
        >
          浏览电影分类
        </Link>
      </div>
    </div>
  );
}